module.exports = __webpack_public_path__ + "img/login-carcelen.d71dbc55.svg";